import React, { useState } from 'react';
import AuthContext  from './AuthContext';

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [user,setUser]=useState({
    id:'',
    centersList:[],
    role:'TEACHER'
  })

  const [isCollapsed,setIsCollapsed]= useState(true)


  const login = () => setIsAuthenticated(true);
  const logout = () => setIsAuthenticated(false);

  return (
    <AuthContext.Provider value={{ isAuthenticated,setIsAuthenticated, login, logout ,teachers,setTeachers,user,setUser,isCollapsed,setIsCollapsed}}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
